/**
 * Scrolls to a section and highlights a specific row in an AG-Grid table
 * @param sectionId - The DOM ID of the section to scroll to
 * @param metricName - The name of the metric/row to highlight (matches the text in the "metric" column)
 */
export function scrollAndHighlightRow(sectionId: string, metricName: string) {
    const section = document.getElementById(sectionId);
    if (section) {
        const yOffset = -100;
        const y =
            section.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
    }

    setTimeout(() => {
        const allRows = document.querySelectorAll('[role="row"]');
        allRows.forEach((row) => {
            const cell = row.querySelector('[col-id="metric"]');
            if (cell?.textContent === metricName) {
                const rowIndex = (row as HTMLElement).getAttribute("row-index");

                const matchingRows = document.querySelectorAll(
                    `[role="row"][row-index="${rowIndex}"]`,
                );
                matchingRows.forEach((r) => {
                    const htmlRow = r as HTMLElement;
                    htmlRow.style.transition = "box-shadow 0.3s ease";
                    htmlRow.style.setProperty(
                        "box-shadow",
                        "inset 0 0 0 2px rgb(156 163 175)",
                        "important",
                    );
                });

                setTimeout(() => {
                    matchingRows.forEach((r) => {
                        const htmlRow = r as HTMLElement;
                        htmlRow.style.boxShadow = "";
                        setTimeout(() => {
                            htmlRow.style.transition = "";
                        }, 300);
                    });
                }, 3000);
            }
        });
    }, 800);
}
